module.exports = __webpack_public_path__ + "static/controlsNo-08a59f03a58df23d8762bfd7da91489c.png";